import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';

import Button from '../../../components/ui/Button';

const CallVolumeChart = () => {
  const [chartType, setChartType] = useState('line');
  const [timeRange, setTimeRange] = useState('7d');

  const chartData = [
    { name: '00:00', calls: 45, answered: 42, abandoned: 3 },
    { name: '02:00', calls: 32, answered: 30, abandoned: 2 },
    { name: '04:00', calls: 28, answered: 26, abandoned: 2 },
    { name: '06:00', calls: 67, answered: 63, abandoned: 4 },
    { name: '08:00', calls: 156, answered: 148, abandoned: 8 },
    { name: '10:00', calls: 234, answered: 221, abandoned: 13 },
    { name: '12:00', calls: 287, answered: 268, abandoned: 19 },
    { name: '14:00', calls: 312, answered: 295, abandoned: 17 },
    { name: '16:00', calls: 298, answered: 284, abandoned: 14 },
    { name: '18:00', calls: 189, answered: 178, abandoned: 11 },
    { name: '20:00', calls: 134, answered: 127, abandoned: 7 },
    { name: '22:00', calls: 89, answered: 84, abandoned: 5 }
  ];

  const timeRanges = [
    { value: '24h', label: '24 Saat' },
    { value: '7d', label: '7 Gün' },
    { value: '30d', label: '30 Gün' },
    { value: '90d', label: '90 Gün' }
  ];

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-6 shadow-subtle">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">Çağrı Hacmi Analizi</h3>
          <p className="text-sm text-slate-600">Saatlik çağrı dağılımı ve yanıtlama oranları</p>
        </div>
        
        <div className="flex items-center space-x-3">
          {/* Time Range Selector */}
          <div className="flex items-center space-x-1 bg-slate-100 rounded-lg p-1">
            {timeRanges?.map((range) => (
              <button
                key={range?.value}
                onClick={() => setTimeRange(range?.value)}
                className={`px-3 py-1 text-sm font-medium rounded-md transition-colors ${
                  timeRange === range?.value
                    ? 'bg-white text-slate-900 shadow-sm'
                    : 'text-slate-600 hover:text-slate-900'
                }`}
              >
                {range?.label}
              </button>
            ))}
          </div>

          {/* Chart Type Toggle */}
          <div className="flex items-center space-x-1">
            <Button
              variant={chartType === 'line' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setChartType('line')}
              iconName="TrendingUp"
            />
            <Button
              variant={chartType === 'bar' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setChartType('bar')}
              iconName="BarChart3"
            />
          </div>
        </div>
      </div>
      <div className="h-80 w-full">
        <ResponsiveContainer width="100%" height="100%">
          {chartType === 'line' ? (
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis 
                dataKey="name" 
                stroke="#64748b"
                fontSize={12}
              />
              <YAxis 
                stroke="#64748b"
                fontSize={12}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'white',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                }}
              />
              <Line 
                type="monotone" 
                dataKey="calls" 
                stroke="#2563eb" 
                strokeWidth={3}
                dot={{ fill: '#2563eb', strokeWidth: 2, r: 4 }}
                name="Toplam Çağrı"
              />
              <Line 
                type="monotone" 
                dataKey="answered" 
                stroke="#10b981" 
                strokeWidth={2}
                dot={{ fill: '#10b981', strokeWidth: 2, r: 3 }}
                name="Yanıtlanan"
              />
              <Line 
                type="monotone" 
                dataKey="abandoned" 
                stroke="#ef4444" 
                strokeWidth={2}
                dot={{ fill: '#ef4444', strokeWidth: 2, r: 3 }}
                name="Terk Edilen"
              />
            </LineChart>
          ) : (
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis 
                dataKey="name" 
                stroke="#64748b"
                fontSize={12}
              />
              <YAxis 
                stroke="#64748b"
                fontSize={12}
              />
              <Tooltip 
                contentStyle={{
                  backgroundColor: 'white',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                }}
              />
              <Bar dataKey="answered" fill="#10b981" name="Yanıtlanan" />
              <Bar dataKey="abandoned" fill="#ef4444" name="Terk Edilen" />
            </BarChart>
          )}
        </ResponsiveContainer>
      </div>
      {/* Legend */}
      <div className="flex items-center justify-center space-x-6 mt-4 pt-4 border-t border-slate-200">
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-blue-600 rounded-full"></div>
          <span className="text-sm text-slate-600">Toplam Çağrı</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-green-500 rounded-full"></div>
          <span className="text-sm text-slate-600">Yanıtlanan</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-3 h-3 bg-red-500 rounded-full"></div>
          <span className="text-sm text-slate-600">Terk Edilen</span>
        </div>
      </div>
    </div>
  );
};

export default CallVolumeChart;